module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出',
};



// WEBPACK FOOTER //
// ./src/lang/nl/header.js